import { TableConfigItemsListType } from '@/components/Table/types/types';
import { BilledEventTableRowType } from '../helpers/helpers';
import { formatDateTimeUTC } from '@/helpers/dateHelpers/dateHelpers';
import CheckedIcon from '@/images/CheckSmallIcon.svg?react';
import DashedIcon from '@/images/DashIcon.svg?react';
import { UtcTooltip } from '@/components/UtcTooltip/UtcTooltip';

export const BILLED_EVENTS_TABLE_CONFIG: TableConfigItemsListType<BilledEventTableRowType> = [
  {
    key: 1,
    name: 'organization__name,-date_created',
    header: 'ORGANIZATION NAME',
    width: '15%',
    hasSort: true,
    getValue({ organizationName }) {
      return { value: organizationName, title: organizationName };
    },
  },
  {
    key: 2,
    name: 'date_created',
    header: 'BILLABLE EVENT DATE',
    width: '15%',
    hasSort: true,
    tooltip: <UtcTooltip message='Billable Event Date is recorded in UTC.' />,
    getValue({ viewDate }) {
      const date = formatDateTimeUTC(viewDate);

      return { value: date, title: date };
    },
  },
  {
    key: 3,
    name: 'wire__name,-date_created',
    header: 'WIRE NAME',
    width: '13%',
    hasSort: true,
    getValue({ wireName }) {
      return { value: wireName, title: wireName };
    },
  },
  {
    key: 4,
    name: 'wire_ref_id',
    header: 'WIRE ID',
    width: '10%',
    getValue({ wireId }) {
      return { value: wireId, title: wireId };
    },
  },
  {
    key: 5,
    name: 'wire__type,-date_created',
    header: 'WIRE TYPE',
    width: '10%',
    hasSort: true,
    getValue({ wireType }) {
      return { value: wireType, title: wireType };
    },
  },
  {
    key: 6,
    name: 'wire__is_pd_provider_kyc_required,-date_created',
    header: 'IDV',
    width: '5%',
    hasSort: true,
    getValue({ is_kyc_required }) {
      return { value: is_kyc_required ? <CheckedIcon /> : <DashedIcon /> };
    },
  },
  {
    key: 7,
    name: 'user__email,-date_created',
    header: 'BILLABLE USER',
    width: '19%',
    hasSort: true,
    getValue({ billableUser }) {
      return { value: billableUser, title: billableUser };
    },
  },
  {
    key: 8,
    name: 'wire__contract__name,-date_created',
    header: 'TRANSACTION NAME',
    width: '13%',
    hasSort: true,
    getValue({ transactionName }) {
      return { value: transactionName, title: transactionName };
    },
  },
];
